import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFarmId } from '~/common/use-farm-id'

export const useSidebarNav = ({ onClose }) => {
  const navigate = useNavigate()
  const { farmId } = useFarmId()

  const buildUrl = useCallback(
    (path, requiresFarm) => {
      if (requiresFarm && farmId) return `${path}?farmId=${farmId}`
      return path
    },
    [farmId],
  )

  const handleClick = useCallback(
    (e, path, requiresFarm) => {
      e.preventDefault()
      navigate(buildUrl(path, requiresFarm))
      onClose()
    },
    [navigate, buildUrl, onClose],
  )

  return { buildUrl, handleClick }
}
